import { RELATORIO_USO_MUTUO } from '../constants/modules';

/**
 * Quem pode acessar /v2/relatorio-uso-mutuo e exportar relatório de pesagem sucata.
 * Requer module configuration RELATORIO_USO_MUTUO vinculada ao userId logado.
 */
export function canViewUsoMutuoReport({ authData, moduleConfigurations }) {
  if (!authData?.id) return false;

  return !!moduleConfigurations?.some(
    (m) => m.codigo === RELATORIO_USO_MUTUO && m.userId === authData.id,
  );
}
